// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue1(props) {
    return (
        <svg
            id="_x31_"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
            style={{
                enableBackground: 'new 0 0 250 250',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"
                }
            </style>
            <g id="LAA">
                <g id="compass">
                    <path
                        className="st0"
                        d="M234.2,205.1l-8.2-4l-5.6-5.8l7.4,3.1L234.2,205.1z"
                    />
                    <path
                        className="st1"
                        d="M239.7,208.7c-4.9,7-14.6,8.8-21.6,3.9c-7-4.9-8.8-14.6-3.9-21.6c4.9-7,14.6-8.8,21.6-3.9 C242.9,192,244.6,201.7,239.7,208.7z M215.3,191.7c-4.5,6.4-2.9,15.3,3.5,19.7c6.4,4.5,15.3,2.9,19.7-3.5 c4.5-6.4,2.9-15.3-3.5-19.7C228.7,183.7,219.8,185.3,215.3,191.7z"
                    />
                    <path
                        className="st0"
                        d="M226.5,196.9c1.6-0.3,3.2,0.8,3.4,2.4c0.3,1.6-0.8,3.2-2.4,3.4c-1.6,0.3-3.2-0.8-3.4-2.4 C223.8,198.7,224.8,197.2,226.5,196.9z M218.7,195.5l-2.5-1.8l0.3-0.4l2.5,0.1l-1.7-1.2l0.3-0.4l2.5,1.8l-0.3,0.4l-2.6-0.1 l1.7,1.2L218.7,195.5z"
                    />
                    <path
                        className="st2"
                        d="M226.7,198.2c0.9-0.2,1.8,0.4,1.9,1.3c0.2,0.9-0.4,1.8-1.3,1.9c-0.9,0.2-1.8-0.4-1.9-1.3 C225.2,199.2,225.8,198.4,226.7,198.2z"
                    />
                </g>
                <g id="distances">
                    <text
                        id="right-right-center"
                        transform="matrix(1 0 0 1 224.3615 99.1749)"
                        className="st3 st4 st5"
                    >
                        350
                    </text>
                    <text
                        id="right-center"
                        transform="matrix(1 0 0 1 180.75 60.1753)"
                        className="st3 st4 st5"
                    >
                        365
                    </text>
                    <text
                        id="center"
                        transform="matrix(1 0 0 1 142.4549 39.0148)"
                        className="st3 st4 st5"
                    >
                        396
                    </text>
                    <text
                        id="left-center"
                        transform="matrix(1 0 0 1 93.0547 40.1971)"
                        className="st3 st4 st5"
                    >
                        390
                    </text>
                    <text
                        id="left-left-center"
                        transform="matrix(1 0 0 1 7.2404 111.3675)"
                        className="st3 st4 st5"
                    >
                        347
                    </text>
                </g>
                <g id="field">
                    <path
                        id="Outfield"
                        className="st6"
                        d="M125,226.5c-13.8,0-17.8-7.4-24.6-15.6c-8.3-10.1-35.3-53.3-39.2-58.3 c-4.4-5.6-8.8-11.2-13.3-16.7c-3.8-4.8-7.6-9.5-11.3-14.2c-1.9-2.4-6-7.5-6-7.6l-2.4-8.1l-0.9-4.4l-0.1-3.7l0.4-3.3l0.8-2.9 l1.2-2.6l1.4-2.4l1.6-2.2l1.8-1.9l1.8-2l1.9-2l1.9-2l1.9-2l1.9-2l1.9-2l1.9-2l2-2.1l2-2.1l2-2.1l2-2.1l2.1-2.2l2.1-2.2l2.3-1.8 l2.8-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7L81,49l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7l2.7-0.7L100,44l2.7-0.7l2.8-0.7 l2.8-0.7l2.8-0.7l2.8-0.7l2.8-0.7l2.8-0.7l2.9-0.8l2.9-0.8l2.9-0.8l2.9-0.8h2.9l2.8,1.5l2.8,1.5l2.7,1.5l2.7,1.5l2.7,1.5l2.6,1.4 l2.6,1.4l2.6,1.4L158,49l2.5,1.4l2.5,1.4l2.5,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.4,1.3l2.3,1.3l2.3,1.3l2.3,1.3 l2.3,1.3l2.3,1.3l2.3,1.3L196,70l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3l2.3,1.3L214,81l1.9,1.9l1.9,1.9l1.6,2.2 l1.4,2.4L222,92l0.8,3l0.3,3.4v3.7l-0.9,4.4l-0.4,0.4l-35.3,49.9c0,0-37.4,55.7-43.8,61.1C137.8,222.1,131.8,226.5,125,226.5 L125,226.5z"
                    />
                    <path
                        id="grass"
                        className="st3"
                        d="M124.6,220.3c-10.9,0-17.2-7.8-21.2-14.3c-4.5-7.2-18.3-28.9-21.4-33.3l-13.2-19.8L36.7,111 l-2.9-6.8l-0.7-3.3L33,98.2l0.3-2.4l0.6-2.1l0.9-1.9L36,90l1.2-1.6l3.4-3.6l23.1-24.5l1-0.8l67.2-17.7h0.6l74.7,40.9l1.6,0.9 l4.8,4.8l1.1,1.5l1.1,1.9l0.8,1.9l0.5,2.1l0.3,2.6v2.7l-0.5,2.5l-32.7,43l-34.3,51.8C149.9,198.6,137.4,220.3,124.6,220.3 L124.6,220.3z"
                    />
                    <path
                        id="infield_sand"
                        className="st6"
                        d="M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
                    />
                </g>
                <g id="persistent">
                    <g id="mound">
                        <path
                            id="pitching-mound"
                            className="st6"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
                        />
                        <path
                            id="pitching-rubber"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4V176.6z"
                        />
                    </g>
                    <g id="lines">
                        <path
                            id="left-foul-line"
                            className="st8"
                            d="M125.2,203.2l-97.1-97.1"
                        />
                        <path
                            id="right-foul-line"
                            className="st8"
                            d="M125.2,203.2l97.1-97.2"
                        />
                    </g>
                    <g id="bases_2_">
                        <rect
                            id="third-base_2_"
                            x={99.2}
                            y={175.1}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="first-base_2_"
                            x={148.1}
                            y={175.2}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="second-base_2_"
                            x={123.7}
                            y={148.6}
                            transform="matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)"
                            className="st10"
                            width={3}
                            height={3}
                        />
                        <polygon
                            id="home_2_"
                            className="st7"
                            points="126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default Venue1
